import { Box, Grid } from "@mui/material";
import LogbookCheckCalendar from "../../components/Fleet/LogbookCheck/LogbookCheckCalendar";

const LogbookCheckPage = () => {
  return (
    <Box className="logbook-check-page">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <LogbookCheckCalendar />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LogbookCheckPage;
